import { render, staticRenderFns } from "./DormRoomListView.vue?vue&type=template&id=b9c6d09c&"
import script from "./DormRoomListView.vue?vue&type=script&lang=js&"
export * from "./DormRoomListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports